import API from "../instances/videociety_instance";
import { PARTNER_IDENTIFIER } from "../partners";
import { standardizeStreamObject } from "../asset";

export const getImage = (type, id, size) => {
  let imageEndpoint;
  let format;
  switch (type) {
    case "cover":
      imageEndpoint = "FrontCover";
      format = "jpg";
      break;
    case "banner":
      imageEndpoint = "CoverWide";
      format = "jpg";
      break;
    case "bg":
      imageEndpoint = "Background";
      format = "jpg";
      break;
    case "screen":
      imageEndpoint = "ScreenShot";
      format = "jpg";
      break;
    case "titleLogo":
      imageEndpoint = "TitleLogo";
      format = "png";
      break;
    default: break;
  }
  return `${process.env.REACT_APP_VC_IMAGES_LINK}${imageEndpoint}/${id}_${size}.${format}`;
};

let VCGenres = [];

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getGenres() {
    return API()
      .get("GetPortalInfo.json?portalId=videociety_de")
      .then((response) => {
        VCGenres = response.data?.PortalInfo?.items || [];
        return VCGenres;
      });
  },
  getGenre(id) {
    let promise;
    if (VCGenres.length > 0) {
      promise = new Promise((resolve) => {
        resolve(VCGenres);
      });
    } else {
      promise = this.getGenres();
    }

    return promise.then((genres) => genres.find((genre) => genre.id === id));
  },
  getTrailer(id) {
    return API().get(
      `StartTrailer.json?articleId=${id}&portalId=videociety_de&deliveryformat=DASH`
    );
  },
  getItems(...ids) {
    return API()
      .get(`GetItem.json?id=${ids.join(",")}&portalId=videociety_de`)
      .then(async (response) => {
        let { items } = response.data;
        if (VCGenres.length <= 0) {
          await this.getGenres();
        }

        items = await Promise.all(
          items.map(async (item) => {
            const images = {};
            if (item?.cover) {
              images.cover = getImage("cover", item.cover, "200");
            }
            if (item?.banner) {
              images.banner = getImage("banner", item.banner, "227x110");
            }
            if (item?.bg) {
              images.bg = getImage("bg", item.bg, "1920");
            }
            if (item?.screen) {
              images.screen = getImage("screen", item.screen, "1920");
            }
            if (item?.titleLogo) {
              images.titleLogo = getImage("titleLogo", item.titleLogo, "640");
            }

            const { stream } = standardizeStreamObject(
              item.webTrailer,
              "video/x-f4v"
            );

            const genres = await Promise.all(
              item.genres.map((id) => this.getGenre(id))
            );

            // todo add standardised stream object

            return {
              ...item,
              images,
              genres,
              partner: PARTNER_IDENTIFIER.VIDEOCIETY,
              stream,
            };
          })
        );
        return items || [];
      });
  },
};
